import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  List,
  ListItem,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import { styled } from "@mui/material/styles";

const TermsModal = ({
  isOpen,
  onClose,
  campaignTitle,
  campaignPeriod,
  terms,
  isCampaign,
  setSignupModalOpen,
}) => {
  const StartNowButton = styled(Button)(({ theme }) => ({
    borderRadius: "40px",
    padding: "12px 24px",
    fontSize: "1rem",
    textTransform: "none",
    background: "linear-gradient(135deg, #238856 0%, #2ab06f 100%)",
    color: "#fff",
    fontWeight: 600,
    boxShadow: "0 4px 15px rgba(35, 136, 86, 0.2)",
    margin: 0,
    minHeight: "42px",
    whiteSpace: "nowrap",
    "&:hover": {
      background: "linear-gradient(135deg, #238856 0%, #2ab06f 100%)",
      color: "#fff",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 20px",
      fontSize: "0.9rem",
    },
  }));

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ p: 0, textAlign: "center", position: "relative" }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            color: (theme) => theme.palette.grey[500],
            border: "1px solid",
            borderColor: (theme) => theme.palette.grey[400],
            borderRadius: "5px",
            padding: "4px",
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        {isCampaign && (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mt: 3 }}>
            <AccessTimeIcon sx={{ color: "#2E7D32", mr: 0.5 }} />
            <MDTypography variant="caption" sx={{ color: "#2E7D32", fontWeight: 500 }}>
              {campaignPeriod}
            </MDTypography>
          </Box>
        )}

        <MDTypography
          variant="h4"
          sx={{
            fontSize: { xs: "1.2rem", md: "1.5rem" },
            fontWeight: 700,
            color: "#1A202C",
            mt: 3,
            mb: 3,
            px: 5,
            textTransform: "none",
            letterSpacing: "-0.02em",
          }}
        >
          {campaignTitle}
        </MDTypography>
      </DialogTitle>

      <DialogContent dividers sx={{ pb: 0, px: 2.5 }}>
        <MDTypography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: "#1A202C",
            mb: 2,
            px: 0.5,
          }}
        >
          {isCampaign ? "Campaign Terms & Condition:" : " Terms & Condition:"}
        </MDTypography>
        <List sx={{ pt: 0, px: 3 }}>
          {terms.map((term, index) => (
            <ListItem key={index} disablePadding sx={{ mb: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    width: 5,
                    height: 5,
                    borderRadius: "50%",
                    bgcolor: "#1A202C",
                    mt: 0.8,
                    mr: 1,
                    flexShrink: 0,
                  }}
                />

                {/* Text */}
                <MDTypography variant="caption" sx={{ color: "#1A202C", lineHeight: 1.6 }}>
                  {term}
                </MDTypography>
              </Box>
            </ListItem>
          ))}
        </List>

        <Box sx={{ textAlign: "center", py: 3 }}>
          <StartNowButton
            onClick={() => {
              setSignupModalOpen(true);
              onClose();
            }}
          >
            Get Started
          </StartNowButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

TermsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  campaignTitle: PropTypes.string.isRequired,
  campaignPeriod: PropTypes.string.isRequired,
  terms: PropTypes.arrayOf(PropTypes.string).isRequired,
  isCampaign: PropTypes.bool.isRequired,
  setSignupModalOpen: PropTypes.func.isRequired,
};

export default TermsModal;
